<template>
  <IndustryDetailRender :indSlug="indSlug" :subIndSlug="subIndSlug"/>
</template>
<script>
import IndustryDetailRender from './IndustryDetailRender'

export default {
  name: 'SubIndustryDetail',
  props: {
    indSlug: {
      type: String
    },
    subIndSlug: {
      type: String
    }
  },
  components: {
    IndustryDetailRender
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/industries/SubIndustryDetail.vue